var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"airpositionDataSourceUl"},[_c('li',{class:_vm.Air.General === true
          ? 'link featureControl featureactive'
          : 'link featureControl ',on:{"click":function($event){$event.stopPropagation();return _vm.switchI('通航飞机')}}},[_vm._v(" 通航飞机 ")]),_c('li',{class:_vm.Air.Transport === true
          ? 'link featureControl featureactive'
          : 'link featureControl',on:{"click":function($event){$event.stopPropagation();return _vm.switchI('运输飞机')}}},[_vm._v(" 运输飞机 ")]),_c('li',{class:_vm.Air.UAV === true
          ? 'link featureControl featureactive'
          : 'link featureControl ',on:{"click":function($event){$event.stopPropagation();return _vm.switchI('无人机')}}},[_vm._v(" 无人机 ")]),_c('li',{class:_vm.Air.Terminal === true
          ? 'link featureControl featureactive'
          : 'link featureControl',on:{"click":function($event){$event.stopPropagation();return _vm.switchI('轻型终端')}}},[_vm._v(" 轻型终端 ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }